import Vue from 'vue'
import Router from 'vue-router'
import Home from './module/home.js'
import Login from './module/login.js'
import User from './module/user.js'
import City from './module/city.js'
import Loan from './module/loan.js'
import Shop from './module/shop.js'
import ExpertList from './module/expert.js'
import CaseList from './module/case.js'
import CommonList from './module/common.js'
import InfoList from './module/info.js'
import Report from './module/report.js'
import Chens from './module/chens.js'

Vue.use(Router)

let routes = []

routes = routes.concat(Home,Login,User,City,Loan,Shop,ExpertList,CaseList,CommonList,InfoList,Report,Chens)

const router =  new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to,from,savedPosition){
        if(savedPosition){
            return savedPosition;
        }else{
            return {x:0,y:0}
        }
    }
});

// 全集导航守卫
router.beforeEach((to, from, next) => {
  // 判断该路由是否需要登录权限
  if (to.matched.some(record => record.meta.requireAuth)){
      // 判断当前的用户是否存在
      if (localStorage.getItem('access_token')) {
          next();
      }else {
          next({
              name: 'Login'
          });
      }
  }else {
      next();
  }
})

// 解决路由内置跳转报错
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router
